<template>
  <section class="block mt10">
    <van-cell
      title="服务费付费模式"
      class="block_header t1"
      :border="false"
    >
    </van-cell>
    <div class="member-card">
      <div
        class="card-border-box"
        v-bind:class="selected === false ? 'active' : ''"
        @click="toggle(false)"
      >
        <div class="box-left">
          <div>
            <van-tag
              class="non-vip-tag"
              type="success"
              color="#04789c"
            ><b>非会员</b></van-tag>

          </div>

          <p class="open-card">
            <span style="color: red;"><b>{{originFee}}</b> 元</span><span class="month-title">/月</span>
          </p>

          <p class="save-money">
            <span>长期代缴建议开通 VIP 会员</span>
          </p>
        </div>
      </div>
      <div
        class="card-border-box"
        v-bind:class="selected ? 'active' : ''"
        @click="toggle(true)"
      >
        <div class="box-left">
          <div class="box-left-title mt5">
            <img
              src="../assets/images/vip.svg"
              alt=""
            >
            <span>一次性会员专享</span>
          </div>
          <p class="open-card mt0">
            <span style="color: red;"><b>{{vipFee}}</b> 元</span><span class="month-title">/月</span>
          </p>
          <p>
            <van-tag
              type="success"
              color="rgb(181 123 23)"
              plain
            ><b>VIP一次性会员费 {{vipServiceFee}}元/人</b></van-tag>
          </p>

          <p class="save-money">
            <span>相比非会员每月<b>省{{originFee - vipFee}}元</b></span>
          </p>
        </div>
      </div>
    </div>
    
      <div
        class="vip-tips"
        v-if="selected"
      >开通会员代表接受<router-link to="/vip-read">《VIP一次性会员费使用须知》</router-link></div>
    
  </section>

</template>

<script>
import { Radio } from "vant";

export default {
  components: {
    [Radio.name]: Radio
  },
  name: "sby-members-card",
  props: {
    value: Boolean,
    vipSelected:  {
      type: Boolean ,
      default: null,
    },
    vipServiceFee: {
      type: Number
    },
    originFee: {
      type: Number
    },
    vipFee: {
      type: Number
    },
  },
  data() {
    return {
      radioOne: "",
      radioChange: false,
      selected: null
    };
  },
 watch: {
    vipSelected(value) {
      this.selected = value;
    }
  },
  methods: {
    toggle(val) {
      if (val === this.selected) {
        this.selected = null;
      } else {
        this.selected = val;
      }
      this.$emit("change", this.selected, this.value);
    },
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/var.less";
.member-card {
  background-color: white;
  display: flex;
  padding: 0 10px 10px 10px;
  .card-border-box {
    display: inline-block;
    flex: 1;
    height: 100px;
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    margin: 5px;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    align-items: center;
    p {
      margin: 0;
      padding: 0;
    }
    .non-vip-tag {
      background-color: rgb(121, 111, 92);
      padding: 0.5px 5px 0.5px 5px;
    }
    .box-left {
      text-align: center;
    }

    .open-card {
      font-size: 16px;
      margin: 5px 0 5px 0;
      text-align: center;
    }
    .month-title {
      font-size: 10px;
      color: #797070;
      margin-left: 2px;
    }
    .save-money {
      color: #bebebe;
      font-size: 10px;
      height: 20px;
      line-height: 20px !important;
      margin-top: 5px;
      img {
        width: 12px;
        height: 12px;
        margin-left: 5px;
        vertical-align: middle;
      }
    }
    .box-right {
      display: flex;
      align-items: center;
      .card-price {
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
  .card-border-box.active {
    border: 1px solid #00cc2c;
    box-shadow: 0 0 3px #00cc2c;
    background: -webkit-gradient(
      linear,
      0% 0%,
      100% 0%,
      from(#ffffff),
      to(#f4fff8)
    );
  }
}
.lifetime-member {
  display: flex;
  justify-content: flex-start;
}
.box-left-title {
  line-height: 13px;
  display: inline-flex;
  img {
    height: 16px;
    border-radius: 5px 0 0 5px;
  }
  span {
    margin-left: -1px;
    font-size: 10px;
    height: 12px;
    background-color: #04789c;
    color: #fff;
    display: inline-block;
    padding: 2px 3px;
    border-radius: 0 2px 2px 0;
    font-weight: bold;
  }
}

.vip-tips {
  background-color: #fff;
  text-align: right;
    padding-right: 10px;
  margin-top: -10px;
  padding-bottom: 10px;
  font-size: 10px;
  color: #bdbdbd;
  a {
    color: #b3cab7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sby-members-card.vue